/* global axios */
import ApiClient from './ApiClient';

// Aba Disparos da caixa (so user id 1; guard no backend InboxPolicy).
// Campanhas de disparo de template: criar, subir itens, disparar/continuar,
// pausar e relatorio paginado.
class InboxDispatchesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  listCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/dispatch_campaigns`);
  }

  createCampaign(inboxId, campaign) {
    return axios.post(`${this.url}/${inboxId}/create_dispatch_campaign`, {
      campaign,
    });
  }

  addItems(inboxId, campaignId, items) {
    return axios.post(`${this.url}/${inboxId}/add_dispatch_items`, {
      campaign_id: campaignId,
      items,
    });
  }

  startDispatch(inboxId, campaignId) {
    return axios.post(`${this.url}/${inboxId}/start_dispatch`, {
      campaign_id: campaignId,
    });
  }

  pauseDispatch(inboxId, campaignId) {
    return axios.post(`${this.url}/${inboxId}/pause_dispatch`, {
      campaign_id: campaignId,
    });
  }

  // TEMPO: muda o intervalo entre envios de uma campanha ja criada (vale ate
  // com ela rodando — o servico rele o intervalo a cada mensagem).
  updateInterval(inboxId, campaignId, intervalSeconds) {
    return axios.post(`${this.url}/${inboxId}/update_dispatch_interval`, {
      campaign_id: campaignId,
      interval_seconds: intervalSeconds,
    });
  }

  // CANCELAR: encerra de vez (o backend marca a campanha como concluida, e
  // nem Continuar nem o lote em grupo a religam).
  cancelDispatch(inboxId, campaignId) {
    return axios.post(`${this.url}/${inboxId}/cancel_dispatch`, {
      campaign_id: campaignId,
    });
  }

  // CSV com TODAS as linhas do filtro atual (a tela pagina de 10 em 10).
  exportItems(inboxId, campaignId, result) {
    return axios.get(`${this.url}/${inboxId}/export_dispatch_items`, {
      params: { campaign_id: campaignId, ...(result ? { result } : {}) },
      responseType: 'blob',
    });
  }

  listItems(inboxId, campaignId, page, result) {
    return axios.get(`${this.url}/${inboxId}/dispatch_campaign_items`, {
      params: { campaign_id: campaignId, page, ...(result ? { result } : {}) },
    });
  }

  // Historico central (menu Meta): campanhas de todas as caixas, 20/pagina.
  history(page, inboxId) {
    return axios.get(`${this.baseUrl()}/meta_central/dispatch_history`, {
      params: { page, ...(inboxId ? { inbox_id: inboxId } : {}) },
    });
  }

  // Disparo em GRUPO (rodizio por mensagem entre caixas): inicia/retoma o
  // lote inteiro pelo token compartilhado das campanhas irmas.
  startGroupDispatch(groupToken) {
    return axios.post(`${this.baseUrl()}/meta_central/start_group_dispatch`, {
      group_token: groupToken,
    });
  }
}

export default new InboxDispatchesAPI();
